import Image from 'next/image';
import Link from 'next/link';
import { RightArrowSvg } from '../Icons';

export default function WayfinderLocator({ block, backgroundColor, position }) {
  const {
    title,
    subtitle,
    input_label,
    show_image_first,
    store_logos,
    image_alt_copy,
    _metadata
  } = block.locator;
  const image_url = block.locator.image.url;

  return (
    <section
      id={`${_metadata.uid}_${position}`}
      data-name={`wayfinder-locator`}
      className={`max-w-container mx-auto w-full bg-[${backgroundColor}]`}
    >
      <div className="standard-padding">
        <div
          className={`flex flex-col justify-center sm:justify-between lg:flex-row sm:items-center${
            show_image_first ? '' : 'lg:flex-row-reverse'
          }`}
        >
          <div className="w-full lg:w-1/2">
            <div>
              {image_url && (
                <Image
                  src={image_url}
                  alt={image_alt_copy}
                  width="1024"
                  height="398"
                  sizes="(min-width: 1024px) 600px, 100vw"
                />
              )}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <div className="px-7 pt-7 pb-0 sm:text-left lg:pb-7">
              {store_logos.length > 0 && (
                <div className="mt-0 flex flex-row items-center justify-center pb-3 lg:justify-start">
                  {store_logos.map((item, index) => {
                    const imageRatio = item.store_logo?.dimension?.height / 24;
                    return (
                      <div
                        className={`${
                          index !== store_logos.length - 1 ? 'pr-10' : ''
                        } max-h-[24px]`}
                        key={index}
                      >
                        <Image
                          src={`${item.store_logo.url}?format=pjpg&auto=webp&disable=upscale`}
                          width={item.store_logo.dimension.width}
                          height={item.store_logo.dimension.height}
                          alt={item.store_logo_alt_copy}
                          sizes={`${item.store_logo.dimension.width / imageRatio}px`}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
              <h2 className="h4 sm:h3 my-4 text-center lg:text-left">
                {title}
              </h2>

              <p className="body-l my-4 text-center lg:text-left">{subtitle}</p>
              {input_label && (
                <Link
                  className="relative mt-3 block"
                  href={'/pages/try-in-store'}
                  prefetch={false}
                >
                  <div className={`flex justify-center lg:justify-start`}>
                    <RightArrowSvg />
                    <span className="txt-btn-secondary h6 lg:h5 ml-[10px] pb-1">
                      {input_label}
                    </span>
                  </div>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
